import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAnalysisJobs, submitSample } from '../../services/api/malwareAnalysisService';

export const loadAnalysisJobs = createAsyncThunk('malwareAnalysis/load', async () => fetchAnalysisJobs());

export const submitAnalysisSample = createAsyncThunk(
  'malwareAnalysis/submit',
  async ({ filename, sha256 }) => submitSample(filename, sha256)
);

const malwareAnalysisSlice = createSlice({
  name: 'malwareAnalysis',
  initialState: { status: 'idle', error: null, jobs: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAnalysisJobs.pending, (state) => { state.status = 'loading'; })
      .addCase(loadAnalysisJobs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.jobs = action.payload;
      })
      .addCase(loadAnalysisJobs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(submitAnalysisSample.fulfilled, (state, action) => {
        state.jobs.unshift(action.payload);
      });
  }
});

export default malwareAnalysisSlice.reducer;
